module.exports = __webpack_public_path__ + "static/z_tall_apples-36ada40f41793f2c8a01981e004a3f4d.jpg";